import IndustryOverviewPortal from './IndustryOverviewPortal'

export default IndustryOverviewPortal
